import { useEffect, useState } from 'react';
import Api from 'entities/helpers/api';
import ErrorLogger from 'entities/helpers/error-log-helper';
import PropTypes from 'prop-types';
import ThreadList from './components/thread-list';
import ThreadListFooter from './components/thread-list-footer';
import EmailDetailHeader from '../components/email-detail-header';
import { useIdentity } from 'base/identity-resolver';

const ThreadDetailController = ({ id }) => {
  const {
    user: { id: userId },
  } = useIdentity();
  const [threadReplies, setThreadReplies] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const fetchThreadReplies = async () => {
      try {
        setLoading(true);
        const res = await Api.OUTREACH.EMAIL_SEARCH.post({
          data: JSON.stringify({
            email: {
              nylas_thread_id: id,
              creator_user_id: userId,
            },
            //excluding scheduled emails from thread details view
            sent_at_start: 0,
          }),
        });
        const { items } = res;
        setThreadReplies(items.reverse());
      } catch (e) {
        ErrorLogger.error('Error getting thread replies', { extra: { e, page_name: 'Thread details view page' } });
      } finally {
        setLoading(false);
      }
    };
    fetchThreadReplies();
  }, [id, userId]);

  const threadSubject = threadReplies[0]?.subject || '(no subject)';

  return (
    <>
      {loading ? (
        <div>Loading...</div>
      ) : (
        !!threadReplies.length && (
          <>
            <EmailDetailHeader subject={threadSubject} />
            <ThreadList threadReplies={threadReplies} />
            <ThreadListFooter threadReplies={threadReplies} />
          </>
        )
      )}
    </>
  );
};

ThreadDetailController.propTypes = {
  id: PropTypes.string,
};

export default ThreadDetailController;
